import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../environments/environment";
import {Storage} from "@ionic/storage";

@Injectable({
    providedIn: 'root'
})
export class ChatService {
    _headers: HttpHeaders;

    constructor(
        private http: HttpClient,
        private storage: Storage
    ) {
        this._headers = new HttpHeaders();
        this._headers = this._headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    }

    getChats(id) {
        let api = environment.api_end_point + '/chatroom/conversation/' + id;
        return this.http.get(api);
    }

    save_message(body) {
        let api = environment.api_end_point + '/chatroom/message';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    get_messages(id) {
        let api = environment.api_end_point + '/chatroom/messages/' + id;
        return this.http.get(api);
    }

    get_bible_messages(body) {
        let api = environment.api_end_point + '/chatroom/biblegetmessages';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    savebiblemessage(body) {
        let api = environment.api_end_point + '/chatroom/savebiblemessage';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }

    savegroupmember(body) {
        let api = environment.api_end_point + '/chatroom/groupmember';
        return this.http.post(api, JSON.parse(body), {headers: this._headers});
    }


}
